import { createEffect } from 'effector'
import {
  getCurrencyRate,
  getPaymentInfo,
  getSpecialOffer,
  getTransactionHistory,
  getTransactionStatus,
  getUpdateProgressInvoiceLink,
  postBuySpecialOffer,
  postCreatePayment,
} from './api'
import {
  ClaimSpecialOfferDTO,
  CreatePaymentDTO,
  GetUpdateProgressPaymentLinkResponse,
  TransactionHistoryParams,
  TransactionStatusDTO,
} from './types'
import { getSubscriptionPrices } from '@/entities/user/api'
import { SubscriptionPriceType } from './types'

export const getCurrencyRatesFx = createEffect(async (token: string) => {
  const rates = getCurrencyRate(token)
  return rates
})

export const getPaymentInfoFx = createEffect(async (token: string) => {
  const response = getPaymentInfo(token)
  return response
})

export const getUpdateProgressInvoiceLinkFx = createEffect(
  async (token: string): Promise<GetUpdateProgressPaymentLinkResponse> => {
    const response = getUpdateProgressInvoiceLink(token)
    return response
  }
)

export const getSubscriptionPricesFx = createEffect(async (token: string): Promise<SubscriptionPriceType[]> => {
  const data = await getSubscriptionPrices(token)
  return data
})

export const getTransactionStatusFx = createEffect(async (params: TransactionStatusDTO) => {
  const response = getTransactionStatus(params)
  return response
})

export const createPaymentFx = createEffect(async (params: CreatePaymentDTO) => {
  const response = postCreatePayment(params)
  return response
})

export const getTransactionHistoryFx = createEffect(async (params: TransactionHistoryParams) => {
  const response = getTransactionHistory(params)
  return response
})
export const getSpecialOfferFx = createEffect(async (token: string) => {
  const response = getSpecialOffer(token)
  return response
})
export const claimSpecialOfferFx = createEffect(async (params: ClaimSpecialOfferDTO) => {
  const response = postBuySpecialOffer(params)
  return response
})
